<div class="filter-history-container" *ngIf="isEnable">
    <mat-form-field class="select">
        <mat-label>{{'filter-history' | translate}}</mat-label>
        <mat-select [value]="recentId" (selectionChange)="setRecent($event)">
            <mat-select-trigger *ngIf="recentTimestamp">{{recentId + 1}}.&nbsp;{{recentTimestamp | date: 'YYYY-MM-dd HH:mm:ss' }}</mat-select-trigger>
            <mat-option *ngFor="let crit of history; let idx=index" [value]="idx" [matTooltip]="getTooltip(idx)"
                matTooltipClass="wide-tooltip">
                <span>{{idx + 1}}.&nbsp;</span><span>{{crit | date: 'YYYY-MM-dd HH:mm:ss'}}</span>
            </mat-option>
        </mat-select>
        <mat-icon matSuffix svgIcon="history"
            class="select-icon"
            (click)="handleActivate($event)"
            [matTooltip]="!manualMode ? ('activate' | translate) : null"></mat-icon>
    </mat-form-field>
    <div class="buttons">
        <button *ngIf="manualMode" [disabled]="saveDisabled" mat-icon-button (click)="save()" color="sims" [matTooltip]="'save' | translate">
            <mat-icon svgIcon="save"></mat-icon>
        </button>
        <button *ngIf="!isEmpty" mat-icon-button (click)="clear()" color="sims" [matTooltip]="'clear' | translate">
            <mat-icon svgIcon="delete"></mat-icon>
        </button>
        <button [disabled]="!hasPrevious" mat-icon-button (click)="previous()" color="sims" [matTooltip]="'previous' | translate">
            <mat-icon svgIcon="undo"></mat-icon>
        </button>
        <button [disabled]="!hasNext" mat-icon-button (click)="next()" color="sims" [matTooltip]="'next' | translate">
            <mat-icon svgIcon="redo"></mat-icon>
        </button>
    </div>
</div>